import { useLayoutEffect } from 'react';
import { WalletType2 } from '@/types/wallet';
import { addReqInterceptor, removeReqInterceptor } from '@web3/base-utils';
import { useWallet } from '@/hooks/wallet';

// 用于给请求增加通用钱包参数
export const useCommonWalletParams = () => {
  const { evmWalletInfo, currentWalletType } = useWallet();

  useLayoutEffect(() => {
    const requestHandle = async (reqData, reqHeaders) => {
      if (!reqHeaders?.useThirdConfig) {
        return reqData;
      }
      delete reqHeaders.useThirdConfig;
      let bybitWalletId = '';

      try {
        bybitWalletId =
          (await window?.bybitWallet?.request({
            method: 'getWalletId',
          })) || '';
      } catch (e) {
        console.log(e);
      }

      if (
        currentWalletType !== WalletType2.MNEMONIC_PHRASE &&
        currentWalletType !== WalletType2.THIRD_PARTY
      )
        return reqData;

      if (reqData.method === 'get') {
        // 如果是GET请求，在params中添加b属性
        reqData.params = reqData.params || {};
        if (!reqData.params.chainId) {
          reqData.params.chainId = evmWalletInfo?.chainId;
        }
        if (!reqData.params.walletAddress) {
          reqData.params.walletAddress = evmWalletInfo?.address;
        }
        reqData.params.walletType = currentWalletType;
        reqData.params.walletId = bybitWalletId;
      }

      if (reqData.method === 'post') {
        // 如果是POST请求，在data中添加b属性
        reqData.data = reqData.data || {};
        if (typeof reqData.data === 'object') {
          if (!reqData.data.chainId) {
            reqData.data.chainId = evmWalletInfo?.chainId;
          }
          if (!reqData.data.walletAddress) {
            reqData.data.walletAddress = evmWalletInfo?.address;
          }
          reqData.data.walletType = currentWalletType;
          reqData.data.walletId = bybitWalletId;
        } else {
          // 如果data不是对象，可能是JSON字符串，需要先转换
          try {
            const dataObj = JSON.parse(reqData.data);
            if (!dataObj.data.chainId) {
              dataObj.data.chainId = evmWalletInfo?.chainId;
            }
            if (!dataObj.data.walletAddress) {
              dataObj.data.walletAddress = evmWalletInfo?.address;
            }
            dataObj.data.walletType = currentWalletType;
            dataObj.data.walletId = bybitWalletId;
            reqData.data = JSON.stringify(dataObj);
          } catch (error) {
            // 处理错误，如不是JSON字符串则可能需要其他方式插入b
            console.error('Error modifying the data:', error);
          }
        }
      }
      return reqData;
    };

    addReqInterceptor(requestHandle);

    return () => {
      removeReqInterceptor(requestHandle);
    };
  }, [evmWalletInfo]);
};
